import { secondsToHours, secondsToMinutes } from 'date-fns';
import { Playlist } from 'types/playlists.types';
import { LoadAudioAction } from 'app/store/AudioPlayer/slice.types';
import { zeroPad } from '../../Song/Audio/AudioTableList/utils';

export const getFormattedTime = (totalSeconds: number, duration: number) => {
  const floorSeconds = Math.floor(totalSeconds);
  const durationIsHour = duration >= 3600;
  const hours = secondsToHours(floorSeconds);
  const minutes = secondsToMinutes(floorSeconds) % 60;
  const seconds = floorSeconds % 60;
  return `${durationIsHour ? `${hours}:` : ''}${
    durationIsHour ? zeroPad(minutes, 2) : minutes
  }:${zeroPad(seconds, 2)}`;
};

export const AUDIO_PLAYER_HEIGHT = 64;
export const AUDIO_PLAYER_WAVEFORM_HEIGHT = AUDIO_PLAYER_HEIGHT;
export const AUDIO_PLAYER_TRANSITION_MS = 300;
export const audioPlayerConfig = {
  height: AUDIO_PLAYER_HEIGHT,
  waveformHeight: AUDIO_PLAYER_WAVEFORM_HEIGHT,
  transitionMs: AUDIO_PLAYER_TRANSITION_MS,
};

export const transformToAudioPlayerAudio: (
  playlist: Playlist
) => LoadAudioAction = (playlist) => ({
  playMode: 'playlist',
  audio: (playlist?.playlistAudios || []).map((el) => ({
    audioGuid: el.audio.guid,
    playlistAudioGuid: el.guid,
    parentGuid: el.song.guid,
    songTitle: el.song.title,
    audioTitle: el.title || el.audio.title,
    note: el.note,
    duration: el.audio.duration,
  })),
  playlistDetails: {
    author: playlist.createdBy.profileCard.displayName || '',
    title: playlist.title || '',
    guid: playlist.guid || '',
    description: playlist.description || '',
  },
});
